import { useEffect } from 'react'

export const useWindowResize = (listener: () => void) => {
  useEffect(() => {
    window.addEventListener('resize', listener)
    return () => window.removeEventListener('resize', listener)
  }, [listener])
}
